<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Update Detail'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '400px' }"
        (onHide)="close()"
>
    <div class="flex flex-col gap-6 my-3">
        <!-- Detail Name Input -->
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-tag"></p-inputicon>
                <input
                        pInputText
                        id="detail-name"
                        [(ngModel)]="detail.name"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Detail Name"
                />
            </p-iconfield>
            <label for="detail-name">Detail Name <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <!-- Is Naming Relevant Checkbox -->
        <div class="flex flex-col gap-1">
            <div class="flex items-center gap-3">
                <p-checkbox
                        binary="true"
                        id="isNamingRelevant"
                        [(ngModel)]="detail.isNamingRelevant"
                ></p-checkbox>
                <label for="isNamingRelevant">Naming Relevant</label>
            </div>

            <p class="text-sm text-gray-400 dark:text-gray-500">
                This will be used to determine if the detail is relevant for naming the sample which uses the detail.
            </p>
        </div>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>

    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Update"
                icon="pi pi-check"
                (click)="updateDetail()"
                [disabled]="saveDisabled"
                [loading]="loading"
        ></p-button>
    </div>
</p-dialog>
